import React, { useState, useEffect, useReducer, useRef, useContext, useCallback } from "react";
import Input from "../UI/Input";
import Button from "../UI/Button";
import Papa from "papaparse";
import AppContext from "../../store/app-context";
import { Plus } from "react-feather";

import styles from "./BulkAdd.module.css";

const productReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    return {
      value: action.value,
      isValidProduct: action.value.trim().length > 0,
    };
  }
  if (action.type === "INPUT_BLUR") {
    return {
      value: state.value,
      isValidProduct: state.value.trim().length > 0,
    };
  }
  return { value: "", isValidProduct: null };
};

const BulkAddForm = (props) => {
  const appCtx = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('Error fetching data...');

  let label_bulkUpload = 'Bulk Upload';
  let label_addList = 'Upload List';
  let label_select_file_msg = 'Please select a file and then click Upload.';
  let label_file_format_error_msg = 'Upload was not successful. Please check your file format, and then try again. You may download a file with the correct format from the provided link.';
  let label_download_file_template = 'Download quote template';
  let label_incorrect_qty_msg = 'Catalog numbers {0} had invalid quantities in the uploaded file, hence the quantity has been changed to 1.Please upload with valid quantities.';
  let label_gt999_qty = 'Please enter a quantity less than or equal to 999 for product [';

  if(appCtx && appCtx.bioradResources){
    label_bulkUpload = appCtx.bioradResources.Bulk_List_Upload ? appCtx.bioradResources.Bulk_List_Upload : 'Bulk Upload';
    label_addList = appCtx.bioradResources.Add_List ? appCtx.bioradResources.Add_List : 'Upload List';
    label_select_file_msg = appCtx.bioradResources.B2C_CH_SC_MSG021 ? appCtx.bioradResources.B2C_CH_SC_MSG021 : 'Please select a file and then click Upload.';
    label_file_format_error_msg = appCtx.bioradResources.B2C_CH_SC_MSG011 ? appCtx.bioradResources.B2C_CH_SC_MSG011 : "Upload was not successful. Please check your file format, and then try again. You may download a file with the correct format from the provided link.";
    label_download_file_template = appCtx.bioradResources.Download_Quote_Bulk_Add_Template ? appCtx.bioradResources.Download_Quote_Bulk_Add_Template : 'Download quote template';
    label_incorrect_qty_msg = appCtx.bioradResources.B2C_CH_SC_MSG030 ? appCtx.bioradResources.B2C_CH_SC_MSG030 : 'Catalog numbers {0} had invalid quantities in the uploaded file, hence the quantity has been changed to 1.Please upload with valid quantities.';
    label_gt999_qty = appCtx.bioradResources.Message_Invalid_Quantity1 ? appCtx.bioradResources.Message_Invalid_Quantity1 : 'Please enter a quantity less than or equal to 999 for product [';
  }

  const [file, setFile] = useState();
  const [data, setData] = useState();
  const [fileError, setFileError] = useState("");
  const [fileFormatError, setFileFormatError] = useState("");
  const [incorrectSkuQtyError, setIncorrectSkuQtyError] = useState("");
  const [qtyGt999Error, setQtyGt999Error] = useState("");
  const allowedFileExtensions = ["csv", "vnd.ms-excel"];

  const itemInputRef = useRef();

  const [productInputState, dispatchProduct] = useReducer(productReducer, {
    value: "",
    isValidProduct: null,
  });

  const [isValidForm, setIsValidForm] = useState(false);

  useEffect(() => {
    setIsValidForm(productInputState.isValidProduct);
    return () => {};
  }, [productInputState.isValidProduct]);

  const fileInputChangeHandler = (event) => {
    setFileError("");
    setFileFormatError("");
    setIncorrectSkuQtyError("");
    setQtyGt999Error("");
    if (event.target.files.length) {
      const inputFile = event.target.files[0];

      // Check the file extensions, if it not
      // included in the allowed extensions
      // we show the error
      const fileExtension = inputFile?.type.split('/')[1];
      if (!fileExtension || !allowedFileExtensions.includes(fileExtension.toLowerCase())) {
        setFileFormatError(label_file_format_error_msg);
        return;
      }

      // If input type is correct set the state
      setFile(inputFile);
      const reader = new FileReader();

      reader.onload = async ({ target }) => {
        Papa.parse(target.result, {
          header: false,
          skipEmptyLines: true,
          complete: function (results) {
            setData(results.data);
          }
        });
        //const parsedData = csv?.data;
        //setData(parsedData);
      };
      reader.readAsText(inputFile);
    }
    //setEnteredProduct(event.target.value);
    dispatchProduct({ type: "USER_INPUT", value: event.target.value });
    //setIsValidForm(event.target.value.trim().length > 0);
  };

  const validateProductHandler = () => {
    //setIsValidProduct(enteredProduct.trim().length > 0);
    dispatchProduct({ type: "INPUT_BLUR" });
  };

  const bulkAddSubmitHandler = (event) => {
    event.preventDefault();

    if (!file || !data) return setFileError(label_select_file_msg);

    let skuList = '';
    let quanityList = '';
    let ignoreLine = false;
    let incorrectQtySkuList = '';
    let skuWithQtyGt999 = '';
    if(data){
      data.forEach((d) => {

        ignoreLine = Object.values(d)[0].includes("#") ? true : false;

        if(!ignoreLine){
          skuList += Object.values(d)[0] + ',';
          let inputQty = parseInt(Object.values(d)[1]);
          // check input qty is valid number
          if(isNaN(inputQty) || !Number.isInteger(inputQty)){
            if(incorrectQtySkuList !== ''){
              incorrectQtySkuList += ', ' + Object.values(d)[0];
            }else{
              incorrectQtySkuList = Object.values(d)[0]
            }
            inputQty = 1;
          }else if(inputQty > 999){ // check if qty is > 999
            if(skuWithQtyGt999 !== ''){
              skuWithQtyGt999 += ', ' + Object.values(d)[0];
            }else{
              skuWithQtyGt999 = Object.values(d)[0];
            }
            inputQty = 999;
          }
          quanityList +=  inputQty + ',';
        }
      });

      if(skuList !== ''){
        props.onAddItem({
          id: Math.random().toString(),
          sku: skuList,
          quantity: quanityList,
          webRef: props?.quote?.webReference,
        });
      }else{
        setFileError(label_select_file_msg);
      }

      if(incorrectQtySkuList !== ''){
        setIncorrectSkuQtyError(label_incorrect_qty_msg.replace('{0}', incorrectQtySkuList));
      }

      if(skuWithQtyGt999 !== ''){
        setQtyGt999Error(label_gt999_qty + skuWithQtyGt999 + ']');
      }
    }

  //setEnteredProduct("");
  setFile();
  setData();
  dispatchProduct({});
 };

 const getFileNameFromContentDispostionHeader = (header, defaultFileName) => {
  let contentDispostion = header.split(';');
  const fileNameToken = 'filename=';

  let fileName = defaultFileName;
  for (let thisValue of contentDispostion) {
      if (thisValue.trim().indexOf(fileNameToken) === 0) {
          fileName = decodeURIComponent(thisValue.trim().replace(fileNameToken, ''));
          break;
      }
  }

  return fileName;
}

  return (
    <form onSubmit={bulkAddSubmitHandler}>
      <div
        className={`${styles.control} ${
          productInputState.isValidProduct === false ? styles.invalid : ""
        }`}
      >
        <Input
          ref={itemInputRef}
          label={label_bulkUpload}
          input={{
            id: "skulist",
            type: "file",
            accept: ".csv",
            value: productInputState.value,
            placeholder: "no file uploaded",
            onChange: fileInputChangeHandler,
            onBlur: validateProductHandler,
          }}
          rebrand = {props?.isNewBrand}
          style={props?.isNewBrand ? {display: "none" } : {marginBottom:'0.5rem'}}
          className = "bulkUpload"
        />

        {props?.isNewBrand && (
          <div className={styles.bulkBtn}>
            <Button
            type="button"
            className={styles.btn}
            onClick={() => itemInputRef.current && itemInputRef.current.click()}
            >
              {label_bulkUpload}
            </Button>
          </div>
        )}

        <div className={props?.isNewBrand === true? styles.newbtn : ''}>
          <Button type="submit" className={styles.btn} >
            {props?.isNewBrand && (<Plus height={14} width={18} style={{paddingRight:"5px"}}/>)}
            {label_addList}
          </Button>
        </div>
        <p className={props?.isNewBrand === true ? styles.downloadTemp : ""}>
          <a href="/templates/BioRad_QuickOrder_Upload_Template.csv" className={styles.btnlinkU} download="BioRad_QuickOrder_Upload_Template.csv">{label_download_file_template}</a>
        </p>
        {fileError !== '' && <span>{fileError}</span>}
        {fileFormatError !== '' && <span>{fileFormatError}</span>}
        {incorrectSkuQtyError !== '' && <span>{incorrectSkuQtyError}</span>}
        {qtyGt999Error !== '' && <span>{qtyGt999Error}</span>}
      </div>
    </form>
  );
};

export default BulkAddForm;
